/**
 * Converts a snake_case / kebab-case role code into a Title Case label.
 * Used only as a last-resort fallback when the API omits a role's display
 * name, so a raw code like `subsidiary_admin` never reaches the UI.
 */
export function humanizeRoleCode(code: string): string {
  return code
    .trim()
    .split(/[_-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
